import SystemKeys from "@/common/utils/SystemKeys";
import { StorageHandler } from "./StorageHandler";
import { SelectionItem } from "@/forms/ViewModelFormTypes";

export class MaterialStorageHandler extends StorageHandler {
  public static getAllMaterials(useIdValues: boolean = true): SelectionItem[] {
    const nameKey = useIdValues ? undefined : SystemKeys.materialNameKey;

    return this.buildTopLevelSelection(
      SystemKeys.materialTableKey,
      SystemKeys.materialNameKey,
      nameKey
    );
  }
}
